import React, {Component} from 'react';
import {Link,withRouter} from 'react-router-dom';
import ReactGA from 'react-ga';
import { CardElement, injectStripe, PaymentRequestButtonElement } from 'react-stripe-elements';
import { Dropdown } from 'semantic-ui-react'
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import SelectButton from '../../../components/icon/SelectButton';
import { Loader } from 'semantic-ui-react'
import * as util from '../../../utils/util';
import { productTypeUpdated, RESPONSE_STATUS } from '../../../utils/constants';
// import { FaCheckCircle, FaCircle, FaFacebook, FaInstagram } from 'react-icons/fa';
import ReactPixel from 'react-facebook-pixel';
import * as zenscroll from 'zenscroll';

import './GateFee.css';
import Api from '../../../utils/api';
import Http from '../../../utils/http';


import { stateData } from '../../../data/states';
import { Button, Divider, Input, Segment } from 'semantic-ui-react'

const indexMapThreeFive = {13:true,14:true};
const indexMapProducts = {1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,11:true,12:true,15:true};
const indexMapProductsRef = {1:"Cleanser",2:"Toner",3:"Moisturizer",4:"SPF",5:"Serum",6:"Eye Cream",7:"Exfoliator",8:"Mask",11:"Make-Up Remover",12:"Treatment",15:"Supplement"};
const indexMapProductsFile = {1:"cleanser",2:"toner",3:"moisturizer",4:"spf",5:"serum",6:"eye-cream",7:"exfoliator",8:"mask",11:"makeup-remover",12:"treatment",15:"supplement"};


class GateFeeProcessing extends Component {
    constructor(props) {
        super(props);

        this.idempotencyKey = Api.getUUID();

        this.changeStepOneStep = this.changeStepOneStep.bind(this);
        this.handleClickDot = this.handleClickDot.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePayment = this.handlePayment.bind(this);
        this.selectPasIcon = this.selectPasIcon.bind(this);
        this.deselectPasIcon = this.deselectPasIcon.bind(this);
        this.saveProducts = this.saveProducts.bind(this);
        this.handleChangePhoneInput = this.handleChangePhoneInput.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleResend = this.handleResend.bind(this);
        this.handleCheckChange = this.handleCheckChange.bind(this);
        this.handleConfirmInput = this.handleConfirmInput.bind(this);
        this.handleConfirmCodeSubmit = this.handleConfirmCodeSubmit.bind(this);
        this.handleSubmitStepOne = this.handleSubmitStepOne.bind(this);
        this.handleCheckChangeShippingAddress = this.handleCheckChangeShippingAddress.bind(this);
        this.checkIfPromoCodeExists = this.checkIfPromoCodeExists.bind(this);
        this.redeemGiftCardInFull = this.redeemGiftCardInFull.bind(this);
        this.saveGateFeeAmount = this.saveGateFeeAmount.bind(this);
        this.fun_createToken_handlePayment = this.fun_createToken_handlePayment.bind(this);

        const paymentRequest = this.props.stripe.paymentRequest({
            country: 'US',
            currency: 'usd',
            total: {
                label: 'Gate Fee',
                amount: 499   ? 499 : 1000,
            },
        });

        paymentRequest.on('token', ({complete, token, ...data}) => {
            this.handlePayment(token);
            complete('success');
        });

        // var elements = this.props.stripe.elements();
        // var prButton = elements.create('paymentRequestButton', {
        //     paymentRequest: paymentRequest,
        //     style: {
        //         paymentRequestButton: {
        //           type: 'default',
        //           // One of 'default', 'book', 'buy', or 'donate'
        //           // Defaults to 'default'
            
        //           theme: 'dark',
        //           // One of 'dark', 'light', or 'light-outline'
        //           // Defaults to 'dark'
        //           borderRadius: '13px',
        //           // Defaults to '40px'. The width is always '100%'.
        //         },
        //       },
        // });

        try {
            paymentRequest.canMakePayment().then((result) =>{
                this.setState({ showPaymentRequestButton: !!result })
                if (result) {
                    // elements.mount('#payment-request-button');
                    try {
                        document.getElementById('pay-button-container').style.justifyContent = 'space-between';
                    } catch (error) {
                        
                    }
                } else {
                    try {
                        if(document.getElementById('payment-request-button')){
                            document.getElementById('payment-request-button').style.display = 'none';
                            document.getElementById('pay-button-container').style.justifyContent = 'center';
                        }
                    } catch (error) {
                        
                    }
                    
                }
            });
        } catch (error) {}
        

        this.state = {
            stepOneStep: 0,
            stepTwoStep: 0,
            showThankYou: props.showThankYouMessage,
            phoneNumber: '',
            confirmCode: null,
            budget: null,
            isEditingProducts: false,
            inputValue: null,
            productTypes: [],
            defaultPurchaseConfirmed: false,
            codeMatch: true,
            paymentRequest: paymentRequest,
            showPaymentRequestButton: false,
            country: '',
            region: '',
            fnameShipping: '',
            lnameShipping: '',
            addressOneShipping: '',
            addressTwoShipping: '',
            cityShipping: '',
            zipShipping: '',
            name: '',
            addressOne: '',
            addressTwo: '',
            city: '',
            zip: '',
            disablePurchaseButton: false,
            showShippingAddressSection: false,
            promoCode: '',
            promoCodeSaved: '',
            amountAvailableForDiscount: 0,
            showPromoSuccessMessage: false,
            promoCodeError: '',
            discountCodes: [],
            discountType: '',
            discountExpirationDate: '',
            disablePromoButton: false,
            phoneCountry:'',
            gateFeeValue: this.props.planValue ? this.props.planValue : 29,
            paymentType: this.props.paymentType ? this.props.paymentType : '',
            stepStep:1,
        }
    }

    componentWillMount() {
        const userId = localStorage.getItem("user_id");
        if (userId) {
            this.fetchResult();
            
            var user_account_info = localStorage.getItem("user_account_info");
            if(util.isJSON(user_account_info)){
               let user_account_infoJson = JSON.parse(user_account_info);
               this.setState({
                phoneCountry: util.transformationCountryNumber(user_account_infoJson.region ? user_account_infoJson.region.id : 1) 
               })
               localStorage.setItem("phoneCountry",util.transformationCountryNumber(user_account_infoJson.region ? user_account_infoJson.region.id : 1) );
               localStorage.setItem("phoneCountryNumber",user_account_infoJson.region ? user_account_infoJson.region.id : 1);
            }

        }
    }

    componentDidMount() {
        this.setState({
            gateFeeValue: this.props.planValue ? this.props.planValue : 29,
            paymentType: this.props.paymentType ? this.props.paymentType : ''
        },()=>{
           
           
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.showThankYouMessage !== this.props.showThankYouMessage) {
            this.setState({ showThankYou: this.props.showThankYouMessage });
            if (this.state.showThankYou) {
                let anchor = document.getElementById("weVeReceived-js");
                zenscroll.center(anchor);
            }
        }
        if (prevProps.phoneNumber !== this.props.phoneNumber) {
            this.setState({ phoneNumber: this.props.phoneNumber });
        }

        if (prevState.country !== this.state.country) {
            this.setState({ region: "" });
        }

        if (prevState.countryShipping !== this.state.countryShipping) {
            this.setState({ regionShipping: "" });
        }
        
        if (prevState.gateFeeValue !== this.props.planValue) {
            this.setState({ gateFeeValue: this.props.planValue,paymentType: this.props.paymentType });
        }

        if(window.paypal && !document.getElementsByClassName("component-frame")[0]){
            this.fun_initPaypal();
        }

    }


    fun_initPaypal(){
        
        if(window.paypal){

            var _this = this;
            var paypalValue = this.state.gateFeeValue;
            var paypalDescription = this.state.paymentType == 'PLAN_ONE' ? 'AVA EXPLORER PACKAGE' : this.state.paymentType == 'UPSELL' ? 'Skin consultation' : this.state.paymentType == 'PLAN_WTO' ? 'AVA EXPERT PLAN' : 'AVA LUXE PLAN';
            window.paypal.Buttons({
                createOrder: function(data, actions) {
                  // This function sets up the details of the transaction, including the amount and line item details.
                  return actions.order.create({
                    purchase_units: [{
                      amount: {
                        value: paypalValue
                      },
                      description:paypalDescription
                    }]
                  });
                },
                onApprove: function(data, actions) {
                  // This function captures the funds from the transaction.
                  return actions.order.capture().then(function(details) {
                    // This function shows a transaction success message to your buyer.
                    _this.fun_createToken_handlePayment(details);
                    // alert('Transaction completed by ' + details.payer.name.given_name);
                  });
                },
                style: {
                    layout:'horizontal',
                    color:'gold',
                    shape:'pill',
                    label:'checkout',
                    tagline: false,
                  }
            }).render('#paypal-button-container');
            //This function displays Smart Payment Buttons on your web page.
        }
    }



    fun_createToken_handlePayment(data){
        try {
            this.handlePayment();
        } catch (error) {
            console.error(error);
        }
        
    }

    gtag_report_conversion_submitPayment(url) {
        let callback = function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
            }
        };
        if(window.gtag)
        window.gtag('event', 'conversion', {
              'send_to': 'AW-782420739/XDIuCJWZ4YwBEIOWi_UC',
              'event_callback': callback
        });
        return false;
    }

    //Get user budget and selected products
    fetchResult() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/surveys/result?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            this.setState({
                inputValue: responseJson.selectedBudgetId,
                productTypes: responseJson.productTypes.length > 0 && (responseJson.productTypes.indexOf(9) === -1 && responseJson.productTypes.indexOf(10) === -1) ? responseJson.productTypes : [1,2,3]
           });
            let indexNine = this.state.productTypes.indexOf(9);
            let indexTen = this.state.productTypes.indexOf(10);
            if (indexNine !== -1) this.state.productTypes.splice(indexNine, 1); 
            if (indexTen !== -1) this.state.productTypes.splice(indexTen, 1);
            localStorage.setItem("estheticianNote", responseJson['estheticianNote']);
        }).catch(function(err) {
            console.log("There was a problem getting your survey result. Please try again.");
        });
    }


    //Add paid user to Airtable via Zapier
    addPaidUsersToZapier(firstName, lastName, phoneNumber, timeStamp, email, paidAmount) {
        const url = 'https://api.airtable.com/v0/app1i1EUDcShUEpYn/gate%20fee%20users';
        fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + process.env.REACT_APP_AIRTABLE_API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "fields": {
                    "First Name": firstName,
                    "Last Name": lastName,
                    "Phone": phoneNumber,
                    "Timestamp": this.convertToStandardTime(timeStamp),
                    "Email": email,
                    "PaidAmount": paidAmount
                }
            })
        });
    }

    convertToStandardTime(timestamp) {
        var d = new Date(timestamp * 1000),    // Convert the passed timestamp to milliseconds
            yyyy = d.getFullYear(),
            mm = ('0' + (d.getMonth() + 1)).slice(-2),  // Months are zero based. Add leading 0.
            dd = ('0' + d.getDate()).slice(-2),         // Add leading 0.
            hh = d.getHours(),
            h = hh,
            min = ('0' + d.getMinutes()).slice(-2),     // Add leading 0.
            ampm = 'AM',
            time;

        if (hh > 12) {
            h = hh - 12;
            ampm = 'PM';
        } else if (hh === 12) {
            h = 12;
            ampm = 'PM';
        } else if (hh === 0) {
            h = 12;
        }

        // ie: 2013-02-18, 8:35 AM
        time = yyyy + '-' + mm + '-' + dd + ', ' + h + ':' + min + ' ' + ampm;

        return time;
    }

    /*** PROMO CODE FLOW ***/

    checkIfPromoCodeExists(e) {
        e.preventDefault();
        
        if (this.state.promoCode.length === 0) {
            alert('No promo code entered. Please enter a promo code.');
            return;
        } 

        this.setState({ disablePromoButton: true });

        // this.checkIfPreviouslyUsedDiscountCode(this.state.promoCode).then(response => response)
        this.checkIfPreviouslyUsedDiscountCode(this.state.promoCode)
        .then(response => {
            // console.log(response);
            if (response) {
                return this.setState({ disablePromoButton: false, showPromoSuccessMessage: true, promoCodeError: "Promo code only has already been used." });
            
            } else {
                const url = '/api/shopify/promo-price-rule?code=' + this.state.promoCode;
                fetch(url, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-auth-token': localStorage.getItem('auth_token')
                    }
                })
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else if (response.status >= 400 && response.status < 500) {
                        this.setState({ disablePromoButton: false, showPromoSuccessMessage: true, promoCodeError: "Promo code does not exist." });
                    } else {
                        this.setState({ disablePromoButton: false, showPromoSuccessMessage: true, promoCodeError: "There was a problem checking the eligibility of your promo code." });
                    }
                })
                .then((resJson) => {
                    if (Math.abs(resJson.price_rule.value) > 0) {
                        let discountCodes = this.state.discountCodes;
                        let expirationDate = resJson.price_rule.ends_at ? resJson.price_rule.ends_at : null;

                        if (resJson.price_rule.prerequisite_subtotal_range && (resJson.price_rule.prerequisite_subtotal_range.greater_than_or_equal_to >= parseFloat(this.props.price))) {
                            this.setState({ showPromoSuccessMessage: true }, () => {
                                this.setState({ promoCodeError: "Promo code " + this.state.promoCodeSaved + " only applies to purchases of $" +  parseFloat(resJson.price_rule.prerequisite_subtotal_range.greater_than_or_equal_to).toFixed(2) + " or more." });
                            });
                            return;
                        }

                        if (this.checkIfPromoCodeHasExpired(expirationDate)) {
                            this.setState({ showPromoSuccessMessage: true }, () => {
                                this.setState({ disablePromoButton: false, promoCodeError: "Promo code " + this.state.promoCode + " has expired." });
                            });
                            return;
                        }

                        if (discountCodes.indexOf(this.state.promoCode) < 0) {
                            discountCodes.push(this.state.promoCode);
                        } else {
                            this.setState({ showPromoSuccessMessage: true }, () => {
                                this.setState({ disablePromoButton: false, promoCodeError: "Promo code " + this.state.promoCode + " has already been redeemed." });
                            });
                            return;
                        }


                        this.setState({ 
                            amountAvailableForDiscount: Math.abs(resJson.price_rule.value),
                            discountType: resJson.price_rule.value_type,
                            // discountExpirationDate: resJson.price_rule.ends_at ? resJson.price_rule.ends_at : "",
                            discountMinimumAmount: resJson.price_rule.prequisite_subtotal_range,
                            discountOncePerCustomer: resJson.price_rule.once_per_customer,
                            showPromoSuccessMessage: true,
                            promoCodeSaved: this.state.promoCode,
                            discountCodes: discountCodes
                        });
                    } else {
                        this.setState({ showPromoSuccessMessage: true, promoCodeSaved: this.state.promoCode }, () => {
                            this.setState({ promoCodeError: "Promo code " + this.state.promoCodeSaved + " has already been redeemed." });
                        });
                    }   
                })
                .catch((err) => {
                    console.log(err);
                });
            }
        })
    }

    redeemGiftCardInFull() {
        const userId = localStorage.getItem("user_id");
        const url = '/api/used-discount-codes';
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': localStorage.getItem('auth_token')
            },
            body: JSON.stringify({
                "code": this.state.promoCodeSaved,
                "userId": userId
            })
        })
        .then((response) => {
            if (response.status >= 400 && response.status < 500) {
                throw new Error("Promo code was already redeemed.");
            } else if (response.status >= 500) {
                throw new Error("Server error.");
            } else {
                return;
            }
        })
        .catch((err) => {
            alert('There was an error redeeming your promo code: ' + err);
        });
    }

    checkIfPreviouslyUsedDiscountCode = (code) => {
        const userId = localStorage.getItem("user_id");
        const url = `/api/used-discount-codes/exist?user-id=${ userId }&code=${ code }`;
        return fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': localStorage.getItem('auth_token')
            }
        })
        .then(response => response.json())
        .then(resJson => {
            return resJson;
        })
        .catch(err => alert("There was a problem checking your discount code."));
    }

    checkIfPromoCodeHasExpired = (date) => {
        if (date === null) {
            return false;
        }
        const expireTime = new Date(date);
        const currentTime = new Date();

        return expireTime.getTime() - currentTime.getTime() < 0;
    }

    /*** END PROMO CODE FLOW ***/


    /*** STEP 1 ***/

    changeStepOneStep() {
        let stepOneStep = this.state.stepOneStep;
        stepOneStep++;
        this.setState({ stepOneStep: stepOneStep}, function() {
            if (stepOneStep === 4) {
                setTimeout(this.changeStepOneStep, 2500);
            } else if (stepOneStep === 5) {
                setTimeout(this.changeStepTwoStep, 1500);
            }
        });
    }



    handleClickDot(num) {
        this.setState({ stepOneStep: num }); 
    }

    handleBack() {
        let stepStep = this.state.stepStep;
        stepStep--;
        this.setState({ stepStep: stepStep});
    }

  

    selectPasIcon(id) {
        const splits = id.split("-");
        let index = splits[1];

        let productTypes = this.state.productTypes;
        index = parseInt(index, 10);
        if ((index !== 13) && (index !== 14)) {
            let indexThirteen = productTypes.indexOf(13);
            let indexFourteen = productTypes.indexOf(14);
            if (indexThirteen > -1) productTypes.splice(indexThirteen, 1);
            if (indexFourteen > -1) productTypes.splice(indexFourteen, 1);
            productTypes.push(parseInt(index,10));
            this.setState({ productTypes: productTypes });
        } else {
            productTypes = [];
            productTypes.push(index);
            this.setState({ productTypes: productTypes });
        }
        
    }

    deselectPasIcon(id) {
        const splits = id.split("-");
        let index = splits[1];

        let productTypes = this.state.productTypes;
        index = parseInt(index, 10);
        productTypes.splice(productTypes.indexOf(index), 1);
        if(this.state.productTypes.indexOf(index) === -1) productTypes.slice(this.state.productTypes.indexOf(index), 1);          
        this.setState({ productTypes: productTypes });    
    }

    saveProducts() {
        const productTypes = this.state.productTypes;
        const userId = localStorage.getItem("user_id");
        const url = "/api/user-product-types?user-id=" + userId + "&options=" + productTypes;
        if (productTypes.length === 0) {
            alert("You must select at least one product type.");
            return;
        }
        fetch(url, {
            method: 'POST',
            headers: {
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                this.setState({ isEditingProducts: false });
                this.fetchResult();
                let anchor = document.getElementById("text-service-js");
                zenscroll.center(anchor);
            } else {
                alert("There is a problem to save the products. Please try again.");
            }
        });
    }

    saveBudget() {
        const userId = localStorage.getItem("user_id");
        const url = "/api/user-profiles";
        fetch(url, {
            method: 'PATCH',
            headers: {
                'x-auth-token': Api.auth_tokenManager(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                userId: userId,
                budgetId: parseInt(this.state.inputValue, 10)
            })
        }).then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                this.fetchResult();
            } else {
                alert("There is a problem saving budget preferences. Please try again.");
            }
        });
    }

    handleEditClick = () => {
        if (this.state.isEditingProducts) {
            this.saveProducts();
        }
        else {
            this.setState({ isEditingProducts: true });
        }
    }


    handleSubmitStepOne() {
        if (this.state.isEditingProducts) {
            this.saveProducts();
        }
        this.changeStepOneStep();
    }

    handleChangeAdddressInput = (e) => {
        e.persist();
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmitShipping = () => {
        const userId = localStorage.getItem("user_id");
        const firstName = this.state.showShippingAddressSection ? this.state.fnameShipping : this.state.firstName;
        const lastName = this.state.showShippingAddressSection ? this.state.lnameShipping : this.state.lastName;
        const address1 = this.state.showShippingAddressSection ? this.state.addressOneShipping : this.state.addressOne;
        const address2 = this.state.showShippingAddressSection ? this.state.addressTwoShipping : this.state.addressTwo;
        const city = this.state.showShippingAddressSection ? this.state.cityShipping : this.state.city;
        const state = this.state.showShippingAddressSection ? this.state.regionShipping : this.state.region;
        const country = this.state.showShippingAddressSection ? this.state.countryShipping : this.state.country;
        const zip = this.state.showShippingAddressSection ? this.state.zipShipping : this.state.zip;
        fetch('/api/shipping-addresses', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            },
            body: JSON.stringify({
                "userId": userId,
                "firstName": firstName,
                "lastName": lastName,
                "address1": address1,
                "address2": address2,
                "city": city,
                "state": state,
                "stateCode": stateData[state],
                "country": country,
                "zip": zip
            })
        })
        .then(response => {
            if (response.status === RESPONSE_STATUS.OK || (response.status >= 200 && response.status < 300)) {
                return;
            } else {
                this.setState({ disablePurchaseButton: false });
                throw new Error("Response status issue.");
            }
        })
        .catch(err => {
            console.log('There was a problem saving your shipping address: ' + err);
        });
        
    }

    saveGateFeeAmount(amount,timestampValue) {
        const url = '/api/gate-fees';
        const userId = localStorage.getItem("user_id");
        var time1 = new Date().getTime();
        var data = {
            "userId": userId,
            "amount": parseFloat(amount).toFixed(2),
            "timestamp": timestampValue
        };
        Http.post(url,data).then(()=>{

            // if(this.state.paymentType == 'UPSELL'){  // UPSELL 类型还需要重新改变plan 
            //     this.saveBudget(4);
            // }if(this.state.paymentType == "PLAN_ONE"){
            //     var time2 = new Date().getTime();
            //     if((time2 - time1) >= 5000 ){
            //         this.props.history.push({ pathname : '/recommendations',state:{ planValue: this.props.planValue, paymentType: this.state.paymentType  } })
            //     }else{
            //         setTimeout(()=>{
            //             this.props.history.push({ pathname : '/recommendations',state:{ planValue: this.props.planValue, paymentType: this.state.paymentType } })
            //         }, time2 - time1);
            //     }
            // }

        })
    }

    saveBudget = async(planTypeValue) => {
        const userId = localStorage.getItem("user_id");
        const url = "/api/user-profiles";
    
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: 'PATCH',
                headers: {
                    'x-auth-token': Api.auth_tokenManager(),
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    userId: userId,
                    tier: planTypeValue
                })
            }).then(response => {
                if (response.status === 200) {
                    resolve('resolve return');
                    localStorage.setItem("planTier",planTypeValue);
                } else {
                    alert("There was a problem saving your budget preferences. Please try again.");
                    reject('reject return');
                }
            });
        })
      }

    
    handleSubmit = (e) => {
        e.preventDefault();
      
        this.setState({ disablePurchaseButton: true });
        if (this.state.country !== "Canada") {
          this.confirmZip(this.state.zip, this.state.region,this.state.country)
          .then(response => {
              if (!response) {
                  this.setState({ disablePurchaseButton: false, errorMessageShow: true, errorMessage: "Please fill out a valid zip code for your billing address state." });
                  return;
              } else {
                  if (this.state.showShippingAddressSection) {
                      this.confirmZip(this.state.zipShipping, this.state.regionShipping, this.state.countryShipping)
                      .then(response => {
                          if (!response) {
                              this.setState({ disablePurchaseButton: false, errorMessageShow: true, errorMessage: "Please fill out a valid zip code for your shipping address state." });
                              return;
                          } else {
                              if ((this.state.country === '' || this.state.region === '') || (this.state.showShippingAddressSection && (this.state.countryShipping === '' || this.state.regionShipping === '')))
                              {
                                  this.setState({ disablePurchaseButton: false, errorMessageShow: true, errorMessage: "Please provide your country and state." });
                                  return;
                              } else {
                                  this.handleSubmitShipping();
                              }
                              
                              if (!this.state.userPaid) {
                                  let name = this.state.firstName + " " + this.state.lastName;
                                  this.setState({ errorMessageShow: false });
                                  this.props.stripe.createToken({
                                      name: name,
                                      address_line1: this.state.addressOne,
                                      address_line2: this.state.addressTwo,
                                      address_city: this.state.city,
                                      address_country: this.state.country,
                                      address_state: this.state.region
                                  }).then(({token}) => {
                                      this.handlePayment(token);
                                  }).catch((err) => {
                                      //Creating token
                                      this.setState({ disablePurchaseButton: false });
                                      this.setState({ errorMessageShow: true, errorMessage: "Please fill out the missing credit card information." });
                                  });
                              } else {
                                  //Submitted payment previously
                                  this.setState( { errorMessageShow: true, errorMessage: "You have already submitted your $10 skincare consultation fee." } );
                              }
                          }
                      });
                  } else {
                  if ((this.state.country === '' || this.state.region === '') || (this.state.showShippingAddressSection && (this.state.countryShipping === '' || this.state.regionShipping === ''))){
                        this.setState({ errorMessageShow: true, errorMessage: "Please provide your country and state." });
                        this.setState({ disablePurchaseButton: false });
                        return;
                        } else {
                            this.handleSubmitShipping();
                        }
                        if (!this.state.userPaid) {
                            let name = this.state.firstName + " " + this.state.lastName;
                            this.setState({ errorMessageShow: false });
                            this.props.stripe.createToken({
                                name: name,
                                address_line1: this.state.addressOne,
                                address_line2: this.state.addressTwo,
                                address_city: this.state.city,
                                address_country: this.state.country,
                                address_state: this.state.region
                            })
                            .then(({token}) => {
                                this.handlePayment(token);
                            })
                            .catch((err) => {
                                //Creating token
                                this.setState({ disablePurchaseButton: false });
                                this.setState({ errorMessageShow: true, errorMessage: "Please fill out the missing credit card information." });
                            });
                        } else {
                            //Submitted payment previously
                            this.setState( { errorMessageShow: true, errorMessage: "You have already submitted your $10 skincare consultation fee." } );
                            this.setState({ disablePurchaseButton: false });
                        }
                  }
                  
              }
          });
      } else {
        if (this.state.showShippingAddressSection && this.state.countryShipping === 'United States') {
            this.confirmZip(this.state.zipShipping, this.state.regionShipping, this.state.countryShipping)
            .then(response => {
                if (!response) {
                    this.setState({ disablePurchaseButton: false, errorMessageShow: true, errorMessage: "Please fill out a valid zip code for your shipping address state." });
                    return;
                } else {
                    if ((this.state.country === '' || this.state.region === '') || (this.state.showShippingAddressSection && (this.state.countryShipping === '' || this.state.regionShipping === '')))
                    {
                        this.setState({ errorMessageShow: true, errorMessage: "Please provide your country and state." });
                        return;
                    } else {
                        this.handleSubmitShipping();
                    }
                    
                    if (!this.state.userPaid) {
                        let name = this.state.firstName + " " + this.state.lastName;
                        this.setState({ errorMessageShow: false });
                        this.props.stripe.createToken({
                            name: name,
                            address_line1: this.state.addressOne,
                            address_line2: this.state.addressTwo,
                            address_city: this.state.city,
                            address_country: this.state.country,
                            address_state: this.state.region
                        })
                        .then(({token}) => {
                            this.handlePayment(token);
                        })
                        .catch((err) => {
                            //Creating token
                            console.log(err);
                            this.setState({ disablePurchaseButton: false });
                            this.setState({ errorMessageShow: true, errorMessage: "Please fill out the missing credit card information." });
                        });
                    } else {
                        //Submitted payment previously
                        this.setState({ disablePurchaseButton: false });
                        this.setState( { errorMessageShow: true, errorMessage: "You have already submitted your $10 skincare consultation fee." } );
                    }
                }
            });
          } else {
            if ((this.state.country === '' || this.state.region === '') || (this.state.showShippingAddressSection && (this.state.countryShipping === '' || this.state.regionShipping === '')))
              {
                this.setState({ disablePurchaseButton: false });
                  this.setState({ errorMessageShow: true, errorMessage: "Please provide your country and state." });
                  return;
              } else {
                  this.handleSubmitShipping();
              }
              
              if (!this.state.userPaid) {
                  let name = this.state.firstName + " " + this.state.lastName;
                  this.setState({ errorMessageShow: false });
                  this.props.stripe.createToken({
                      name: name,
                      address_line1: this.state.addressOne,
                      address_line2: this.state.addressTwo,
                      address_city: this.state.city,
                      address_country: this.state.country,
                      address_state: this.state.region
                  })
                  .then(({token}) => {
                      this.handlePayment(token);
                  })
                  .catch((err) => {
                      //Creating token
                      this.setState({ disablePurchaseButton: false });
                      this.setState({ errorMessageShow: true, errorMessage: "Please fill out the missing credit card information." });
                  });
              } else {
                  //Submitted payment previously
                  this.setState({ disablePurchaseButton: false });
                  this.setState( { errorMessageShow: true, errorMessage: "You have already submitted your $10 skincare consultation fee." } );
              }
          }
      }
    }

    //Confirm Check
    handleCheckChange() {
        this.setState({ defaultPurchaseConfirmed: !this.state.defaultPurchaseConfirmed });
    }

    //Checkbox for Showing Shipping Address Section
    handleCheckChangeShippingAddress() {
        this.setState({ showShippingAddressSection: !this.state.showShippingAddressSection });
    }

    handleBlurInputCenter() {
        let anchor = document.getElementById("inputPhoneNumber");
        zenscroll.center(anchor);
    }
    handleBlurInputCodeCenter() {
        let anchor = document.getElementById("inputPhoneCode");
        zenscroll.center(anchor);
    }


    handleChangePhoneInput = (e) => {
        let output = e.target.value;
        let phoneOutput;
        if (e.target.name === 'phoneNumber') {
            let input = output;
            input = input.replace(/[^0-9]/g, '');

            let area = input.substr(0,3);
            let pre = input.substr(3,3);
            let last = input.substr(6,4);

            if(this.state.phoneCountry == 'UK'){
                phoneOutput = output.substr(0, 10);
              }else{
                if (area.length < 3) {
                  phoneOutput = "(" + area;
                } else if (area.length === 3 && pre.length < 3) {
                  phoneOutput = "(" + area + ") " + pre;
                } else if (area.length === 3 && pre.length === 3) {
                  phoneOutput = "(" + area + ") " + pre + "-" + last;
                }
            }

            // phoneOutput = input;
            this.setState({ [e.target.name]: phoneOutput });
            return;
        }else if(e.target.name === "phoneCountry"){
            this.setState({
              phoneNumber: ''
            });
        }

        this.setState({ [e.target.name]: output });
        e.preventDefault();
        e.stopPropagation();
    }

    handleKeyDownPhoneInput = (e) => {
        let key = e.keyCode;
        if (key === 46) {
            let output = e.target.value;
            if (output.slice(-1) === ' ') {
                output = output.substring(0, output.length - 2);
            } else {
                output = output.substring(0, output.length - 1);
            }
            this.setState({ [e.target.name]: output });
        } else if (key === 8) {
            let output = e.target.value;
            let lastChar = output.charAt(output.length - 1);
            if (lastChar === '-' || lastChar === '(' || lastChar === ')') {
                output = output.substring(0, output.length - 1);
            } else if (lastChar === ' ') {
                output = output.substring(0, output.length - 2);
            }
            this.setState({ [e.target.name]: output });
        }
        e.stopPropagation();
    }


    handleResend() {
        const randomNum = Math.floor(Math.random()*90000) + 10000;
        const firstName = this.props.firstName;
        const lastName = this.props.lastName;
        const email = this.props.email;
        const phoneNumber = this.state.phoneNumber;

        this.addMobileUserToAirtable(firstName, lastName, phoneNumber, email, randomNum);
        this.sendConfirmationCodeEntryToZapier(firstName, lastName, phoneNumber, email, randomNum);
        this.sendConfirmationToApi(phoneNumber, randomNum);
    }

    addMobileUserToAirtable(firstName, lastName, phoneNumber, email, verificationCode) {
        const url = 'https://api.airtable.com/v0/appcB3FMnoHGLoRgj/Verification%20Flow';
        fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + process.env.REACT_APP_AIRTABLE_API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "fields": {
                    "First Name": firstName,
                    "Last Name": lastName,
                    "Phone": "+"+util.getCountry(this.state.phoneCountry)+' '+phoneNumber,
                    "Email": email,
                    "Verification Code": verificationCode.toString()
                }
            })
        });
    }

    sendConfirmationCodeEntryToZapier(firstName, lastName, phoneNumber, email, verificationCode) {
        const url = 'https://hooks.zapier.com/hooks/catch/2569749/al95xn/';
        // const url = 'https://hooks.zapier.com/hooks/catch/2569749/oyippjp/';

        const phone = "+"+util.getCountry(this.state.phoneCountry)+" " + phoneNumber;
        fetch(url, {
                method: 'POST',
                body: JSON.stringify({
                    "First Name": firstName,
                    "Last Name": lastName,
                    "Phone": phone,
                    "Email": email,
                    "Verification Code": verificationCode.toString()
                })

        })
        .catch(function(err) {
            alert("There was a problem getting your info. Please try again.");
        });

    }

    sendConfirmationToApi(phone, randomNum) {
        const userId = localStorage.getItem("user_id");
        const code = randomNum.toString();
        fetch('/api/user-profiles/phone-number-verification', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            },
            body: JSON.stringify({
                    "userId": parseInt(userId, 10),
                    "phoneNumber": phone,
                    "phoneNumberVerificationCode": code,
                    "regionId":Number(util.transformationCountryNumberId(this.state.phoneCountry)),
                })
        })
        .then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                this.setState({ codeToVerify: randomNum });
            }
        });
    }

    //Confirmation Code
    handleConfirmInput = (e) => {
        let input = e.target.value;
        input = input.replace(/[^0-9]/g, '');
        this.setState({
            confirmCode: input
        });
    }

    //Confirm code submit
    handleConfirmCodeSubmit() {
        let confirmCode = parseInt(this.state.confirmCode, 10);
        const userId = localStorage.getItem("user_id");
        const url = '/api/user-profiles/phone-number-verification?user-id=' + userId + '&verification-code=' + confirmCode;
        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then((response) => response.json()).then(responseJson => {
            if (responseJson) {
                this.setState({
                    codeMatch: true
                }, this.changeStepTwoStep);
            } else {
                this.setState({
                    codeMatch: false
                });
            }
        })
        .catch(function(err) {
            alert("There was a problem getting the confirmation code. Please try again.");
        });
    }

    confirmZip = (zip, state,country) => {
        const stateCode = stateData[state];
        const url = `/api/taxjar/zip-state-match?zip=${zip}&state=${stateCode}&country=${country}`
        return fetch(url , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then((response) => {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else {
                this.setState({ disablePurchaseButton: false });
                throw new Error("Error confirming zip.")
            }
            
        }).then(responseJson => {
            return responseJson;
        }).catch(function(err) {
            alert("There was a problem confirming your address. Please try again.");
        });
    }

    openApplePayView(e){
        try {
            e.preventDefault();
            this.state.paymentRequest.show();
        } catch (error) {
        }
        
    }

    //Render section
    renderPaymentSection() {
        return(
            <div style={{marginTop:'0px',paddingTop: '30px'}} className="checkout-block-content">
                <div style={{ paddingTop: '0em'}} className="checkout-block-content-section bottom-checkout-section">
                    <div className={"checkout-form" }>

                        <div className="submi-pay-title">
                        {/* h5-title */}
                            <div className="h5-title" style={{textAlign:"center"}}>Submit payment</div>
                            <div className="submi-pay-ti-con">
                                <div className="title-h2">Payment Summary</div>

                                <div className="submi-pay-ti-con-text">
                                    
                                    {
                                        this.state.paymentType == 'PLAN_ONE' ? <span>AVA EXPLORER PACKAGE</span> :
                                        this.state.paymentType == 'UPSELL' ? <span>Skin consultation</span> :
                                        this.state.paymentType == 'PLAN_WTO' ? <span>AVA EXPERT PLAN</span> :
                                        this.state.paymentType == 'BOARDING_PAY' ? <span>Consultation fee</span>:
                                        <span>AVA LUXE PLAN</span>
                                    }

                                    <span className="fo-blod">${this.state.gateFeeValue}</span>
                                </div>
                                {
                                    this.state.paymentType == 'BOARDING_PAY' ? <div style={{textAlign:'left',fontSize:'11px'}} className="paragraph4">credited toward your purchase</div>:null
                                }
                                

                                {
                                    this.state.paymentType == 'PLAN_ONE' ? <div style={{textAlign:'left',fontSize:'11px'}} className="paragraph4">$10 credit will be applied in your first purchase</div> : null
                                }
                            </div>
                        </div>

                        {/* <form id="checkout-form" onSubmit={this.handleSubmit}> */}
                            <div className="block-content checkout area-pa" style={{marginTop:'0'}}>
                                                                    
                                 <div className="credit-card-header">
                                    <h4>Express checkout</h4>
                                </div>
                               
                                    <div>
                                        <div className="icon-area-pay" id="pay-button-container">
                                            <div id="paypal-button-container" style={{width: '117px', height: '25px', borderRadius: '13px',flexBasis:'46%'}}  lang="en" className="paypal-button-container"></div>
                                            <button style={this.state.showPaymentRequestButton ? {display:'block'}:{display:'none'}} id="payment-request-button" className="apple-pay-custom-button" onClick={(e)=>{ this.openApplePayView(e) }}> <i className="fa fa-lg fa-apple" style={{fontSize:'11px'}}></i> Pay</button>
                                            {/* <div id="payment-request-button" onClick={()=>{ this.openApplePayView() }} lang="en" style={{'-webkit-appearance': '-apple-pay-button', '-apple-pay-button-type': 'plain', '-apple-pay-button-style': 'black', width: '117px', height: '20px',minHeight:'20px !important', maxHeight:'25px !important', boxSizing: 'border-box',  borderRadius: '13px'}}></div> */}
                                        </div>
                                        <Divider horizontal>or</Divider>
                                    </div>

     
                                {/* <div className="credit-card-logos">
                                    <div className="credit-card-logo"><img alt="Visa" src="/images/gate/visa.png" /></div>
                                    <div className="credit-card-logo"><img alt="Mastercard" src="/images/gate/mastercard.png" /></div>
                                    <div className="credit-card-logo"><img alt="Discover" src="/images/gate/discover.png" /></div>
                                    <div className="credit-card-logo"><img alt="American Express" src="/images/gate/amex.png" /></div>
                                    <div className="credit-card-logo"><img alt="JCB" src="/images/gate/jcb.png" /></div>
                                    <div className="credit-card-logo"><img alt="Diner's" src="/images/gate/diners.png" /></div>
                                </div> */}

                                <label>
                                    <div className="card-label number">Credit Card Number</div>
                                    <CardElement
                                        style={{
                                            base: {
                                                color: '#272d67',
                                                fontSize: '12px',
                                                fontFamily: 'Montserrat, Helvetica, Arial, sans-serif'
                                            }
                                        }}
                                        hidePostalCode={ true }
                                    />
                                </label>

                                <div className="fname-lname-row">
                                        <label>
                                            <div className="card-label addressOne">First Name</div>
                                            <input onChange={ this.handleChangeAdddressInput }  name="firstName" value={ this.state.firstName } type="text" placeholder="" required/>
                                        </label>

                                        <label>
                                            <div className="card-label addressOne">Last Name</div>
                                            <input onChange={ this.handleChangeAdddressInput }  name="lastName" value={ this.state.lastName } type="text" placeholder="" required/>
                                        </label>
                                    </div>
                                <label>
                                   
                                    <div className="card-label promo-code">Promo Code</div>
                                     <div className="promo-code-row">
                                        <input className="promo-input" onChange={ this.handleChangeAdddressInput } onFocus={ () => { this.setState({ showPromoSuccessMessage: false, promoCodeError: '' }) } } name="promoCode" value={ this.state.promoCode } type="text" placeholder="" />
                                        <button onClick={ this.checkIfPromoCodeExists }>Redeem Code</button>
                                    </div>
                                    {
                                        this.state.showPromoSuccessMessage ?
                                            this.state.promoCodeError.length === 0 ?
                                                <div className="promo-success-message">Promo code { this.state.promoCodeSaved } redeemed!</div> :
                                                <div className="promo-success-message promo-error">{ this.state.promoCodeError }</div> 
                                        : null
                                    }
                                </label>

                                <div className="address-section billing-info">
                                    <div className="credit-card-header">
                                        <h4>Billing information</h4>
                                    </div>

                                    <label>
                                        <div className="card-label addressOne">Address Line 1 (Street)</div>
                                        <input onChange={ this.handleChangeAdddressInput }  name="addressOne" value={ this.state.addressOne } type="text" placeholder="" required />
                                    </label>

                                    <label>
                                        <div className="card-label addressTwo">Address Line 2 (Apt Number)</div>
                                        <input onChange={ this.handleChangeAdddressInput }  name="addressTwo" value={ this.state.addressTwo }type="text" placeholder="" />
                                    </label>
                                    
                                    <div className="gate-input-area">
                                        <label>
                                            <div className="card-label city">City</div>
                                            <input onChange={ this.handleChangeAdddressInput }  name="city" value={ this.state.city } type="text" placeholder="" required />
                                        </label>

                                         <label>
                                            <div className="card-label country">Country</div>
                                            <CountryDropdown
                                                value={this.state.country}
                                                defaultOptionLabel="Select Country"
                                                onChange={(val) => this.selectCountry(val)}
                                                whitelist={["US", "CA", "GB"]}
                                            />
                                        </label>
                                    </div>

                                  

                                    <div className="gate-input-area">
                                        <label>
                                            <div className="card-label state">State</div>
                                            <RegionDropdown
                                                country={this.state.country}
                                                value={this.state.region}
                                                defaultOptionLabel={this.state.country === "United States" ? "State" : "Province"}
                                                onChange={(val) => this.selectRegion(val)}
                                            />
                                        </label>

                                        <label>
                                            <div className="card-label zip">Zip Code</div>
                                            <input onChange={ this.handleChangeAdddressInput }  name="zip" value={ this.state.zip } type="text" placeholder="" maxLength="7" required />
                                        </label>
                                    </div>


                                </div>
                            </div>
                        {/* </form> */}
                    </div>
                </div>
            </div>
        );
    }

    //Payment
    handlePayment(token) {
        const userId = localStorage.getItem("user_id");
        let amount = this.state.gateFeeValue;

        let amountAfterDiscount = 0; 

        if (this.state.discountType !== "percentage") {
            amountAfterDiscount = amount - parseFloat(this.state.amountAvailableForDiscount) > 0 ? amount - parseFloat(this.state.amountAvailableForDiscount) : 0;
        } else {
            amountAfterDiscount = amount * ((100 - parseFloat(this.state.amountAvailableForDiscount)) / 100) >= 0 ? amount * ((100 - parseFloat(this.state.amountAvailableForDiscount)) / 100) : 0;
        }
        
        let finalAmount = this.state.amountAvailableForDiscount > 0 ? amountAfterDiscount : amount;
        
        if(localStorage.getItem("planTier") == '5'){
            window.fbq('track', 'ExplorerPlan', {currency: "USD", value: 10.00});
        }if(localStorage.getItem("planTier") == '2'){
            window.fbq('track', 'ExpertPlan', {currency: "USD", value: 29.00});
        }else if(localStorage.getItem("planTier") == '3'){
            window.fbq('track', 'LuxePlan', {currency: "USD", value: 69.00});
        }


        var timestampValue = "";
        var bodyParam = {};
        if(token){
            timestampValue = this.convertToStandardTime(token.created);
            bodyParam = {
                "userId": userId,
                "stripeToken": token.id,
                "amount": parseFloat(finalAmount).toFixed(2),
                "idempotencyKey": this.idempotencyKey,
                "timestamp": timestampValue,
            }
        }else{
            timestampValue = this.convertToStandardTime( Math.round(new Date() / 1000));
            bodyParam = {
                "userId": userId,
                "amount": parseFloat(finalAmount).toFixed(2),
                "idempotencyKey": this.idempotencyKey,
                "timestamp": timestampValue,
            }
        }


        fetch('/api/gate-fee', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            },
            body: JSON.stringify(bodyParam)
        })
        .then((response) =>
            {
                if ((response.headers.get('x-helloavaapp-error') && (response.status >= 400))) {
                    //Error handling
                    this.idempotencyKey = Api.getUUID();
                    this.setState({ disablePurchaseButton: false });
                    this.setState({ errorMessageShow: true, errorMessage: response.headers.get('x-helloavaapp-error') });
                    throw new Error(response.headers.get('x-helloavaapp-error'));
                } else {
                    this.setState({ userPaid: true, errorMessageShow: false }, function() {
                        if (this.state.promoCodeSaved.length > 0 && this.state.discountOncePerCustomer) this.redeemGiftCardInFull();
                        if (process.env.REACT_APP_ENV === 'prod') {
                            ReactGA.event({
                                category: "Gate Fee",
                                action: "Paid",
                                label: "Paid Gate Fee",
                                value: 1
                            });
                        }
                        if(this.state.paymentType != 'PLAN_ONE'){  // 选择了超过$10的plan才会有咨询服务
                            this.props.fun_changeStepStep();
                        }
                    });

                    if(this.state.paymentType == 'PLAN_ONE'){  // 选择了超过$10的plan才会有咨询服务,所有直接跳转到产品推荐页面
                        this.props.fun_changeStepStep("explorer");
                    }

                    if(this.state.paymentType == 'BOARDING_PAY'){  // 新的onboarding
                        this.props.fun_changeStepStep();
                    }

                    

                    localStorage.setItem("gateFeePaid",true);
                      

                    this.saveGateFeeAmount(finalAmount,timestampValue);
                    // 这个放后台去调用了
                    // this.addPaidUsersToZapier(this.props.firstName, this.props.lastName, this.props.phoneNumber, token.created, this.props.email, parseFloat(finalAmount).toFixed(2));
                    
                    // document.getElementById("PaymentRequestButton").setAttribute("disabled", "disabled");
                    //Removed ReactPixel Purchase 07/22/2019
                    // ReactPixel.track('Purchase', {value: '10.00', currency: 'USD'});
                    // this.gtag_report_conversion_submitPayment();
                    window.fbq('trackCustom', 'PaidGateFee');
                    //Removed Purchase 07/22/2019
                    // window.fbq('track', 'Purchase', { value: '10.00', currency: 'USD' });
                }
                response.json();
            })
        .catch((err) => {
            //Error in payment/server issue
            this.setState({ disablePurchaseButton: false });
            this.setState( { errorMessageShow: true, errorMessage: "There was an error in making a payment. Please try again." } );
        });
    }

    selectCountry(val) {
      this.setState({ country: val });
    }

    selectCountryShipping(val) {
        this.setState({ countryShipping: val });
    }

    selectRegion(val) {
        this.setState({ region: val });
    }

    selectRegionShipping(val) {
        this.setState({ regionShipping: val });
    }


    renderErrorMessage() {
        if (this.state.errorMessageShow) return <div className="user-paid error-confirm">{ this.state.errorMessage }</div>;
        else return null;
    }

    render() {
       return(
            <div id="gate-fee-checkout" style={{marginTop:'31px'}}>
                <form id="checkout-form" onSubmit={this.handleSubmit} style={{width:'100%'}}>
                    <div name="pay-view" className="pay-view">
                        <div id="payment-block" style={{width:'100%', maxWidth:'562px',marginTop:'0'}} className={ "checkout-block step-2 cen-sty complete-purchase-area" }>
                                { this.renderPaymentSection() }
                                { this.renderErrorMessage() }
                        </div>
                        <div className="complete-purchase-button">
                            <button type="submit" id="PaymentRequestButton" style={{position:'relative'}} className="p-a-n-button gateFeff-submit-but" disabled={ this.state.disablePurchaseButton } >Submit Payment
                                <Loader onClick={(e)=>{ e.stopPropagation()}} active={this.state.disablePurchaseButton} inverted size='huge' className={"but-load-style"}/>
                            </button>
                            {
                                this.state.paymentType == "UPSELL" ? null :   ( this.props.paymentType == 'BOARDING_PAY' ?  <div><a onClick={()=>{this.props.fun_changeStepStep('back')}} className="link-view-sty">Back to package page</a> </div> : <div><Link to="/plan" className="link-view-sty">Back to package page</Link> </div>   )   
                            }
                        </div>
                    </div>
                </form>
            </div>
       );
    }
}

export default withRouter(injectStripe(GateFeeProcessing));



// WEBPACK FOOTER //
// ./src/views/AA/gateFee/GateFeeProcessing.js